const AdobeTracking = () => {

    const track = (eventName, data) => {
        
        // NOTE TO SELF: For unknown reasons, the event has to be stored in a variable before being dispatched.
        // ALSO NOTE: That all values has to be passed as string even if they are numbers or booleans
        var event = new CustomEvent('pfAnalytics', {
            detail: [
                {
                    'event': eventName,
                    [eventName]: data
                }
            ]
        });

        console.log(event);
        document.querySelector('body').dispatchEvent(event);
    }

    return {
        track
    }
}

export default AdobeTracking